import React from "react";
import PropTypes from "prop-types";
import { getMessage } from "../data/locales";

function StudentTrackingPagination({
  page,
  totalPages,
  from,
  to,
  total,
  onPrev,
  onNext,
}) {
  if (total === 0) return null;

  return (
    <div className="pa-pagination" data-testid="pa-pagination">
      <p className="pa-pagination-status" aria-live="polite">
        {getMessage("studentTracking.pageStatus", { from, to, total })}
      </p>
      {totalPages > 1 ? (
        <div className="pa-pagination-controls">
          <button
            type="button"
            className="pa-page-btn"
            onClick={onPrev}
            disabled={page <= 1}
          >
            {getMessage("studentTracking.pagePrev")}
          </button>
          <span className="pa-pagination-label">
            {getMessage("studentTracking.pageLabel", { page, totalPages })}
          </span>
          <button
            type="button"
            className="pa-page-btn"
            onClick={onNext}
            disabled={page >= totalPages}
          >
            {getMessage("studentTracking.pageNext")}
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default StudentTrackingPagination;

StudentTrackingPagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};
